<template>
  <div>
    <div class="alert alert-success mb-0" v-if="this.isAnswerSaved">
      {{ $t('views.retailer.applications.retailerSurveyCard.your_answer_is_submitted') }}
    </div>
    <div v-else>
      <template v-for="(question, i) in questions" :key="i">
        <div v-show="question.requirements.length < 1" class="col-md-12 mb-1" :id="'q_' + question.id">
          <label class="col-form-label">
            {{ question.body }}
            <small class="fst-italic" v-if="question.description"> ({{ question.description }}) </small>
          </label>
          <!-- type single select start -->
          <div :class="status(question)" v-if="question.type === QUESTION_TYPES.SINGLE_SELECT">
            <base-multiselect
              v-model="question.selected"
              placeholder=""
              selectedLabel=""
              label="body"
              track-by="id"
              :options="question.choices"
              :multiple="false"
              :hide-selected="true"
              @select="$event => singleSelect($event)"
              @close="formClickSendEvent"
              @open="formClickSendEvent"
            ></base-multiselect>
          </div>
          <!-- type single select end -->

          <!-- type multiple select start -->
          <div :class="status(question)" v-else-if="question.type === QUESTION_TYPES.MULTIPLE_SELECT">
            <base-multiselect
              v-model="question.selected"
              placeholder=""
              selectedLabel=""
              label="body"
              track-by="id"
              :options="question.choices"
              :multiple="true"
              :hide-selected="true"
              @select="$event => multipleSelect($event)"
              @remove="removeSelect"
              @open="formClickSendEvent"
              @close="formClickSendEvent"
            ></base-multiselect>
          </div>
          <!-- type multiple select end -->
          <div v-else v-for="(choice, index) in question.choices" :key="i + index" class="mb-2">
            <!-- type input start -->
            <div :class="status(question)" v-if="question.type === QUESTION_TYPES.INPUT">
              <base-question-input
                :choice="choice"
                placeholder=""
                @updateQuestionInput="updateInput"
                @click="formClickSendEvent"
              />
            </div>
            <!-- type input end -->

            <!-- type checkbox start -->
            <div
              class="custom-control custom-checkbox"
              v-if="question.type === QUESTION_TYPES.CHECKBOX"
              :class="status(question)"
            >
              <input
                type="checkbox"
                class="custom-control-input"
                :id="'choice_' + choice.id"
                :value="choice.id"
                @click="
                  () => {
                    formClickSendEvent()
                    check(choice, $event)
                  }
                "
              />
              <label class="custom-control-label fw-normal" :for="'choice_' + choice.id">{{ choice.body }}</label>
            </div>
            <!-- type checkbox end -->

            <!-- type radio button start -->
            <div
              class="custom-control custom-radio"
              v-if="question.type === QUESTION_TYPES.RADIO"
              :class="status(question)"
            >
              <input
                type="radio"
                :id="'choice_' + choice.id"
                :name="question.id"
                class="custom-control-input"
                :value="choice.id"
                @change="
                  () => {
                    formClickSendEvent()
                    updateRadio(choice, $event)
                  }
                "
              />
              <label class="custom-control-label fw-normal" :for="'choice_' + choice.id">{{ choice.body }}</label>
            </div>
            <!-- type radio button end -->
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required, requiredIf } from '@vuelidate/validators'
import _ from 'lodash'
import Nprogress from 'nprogress'
import { event } from 'vue-gtag'

import { validationMixin } from '@/mixins/validationMixin'

import { QUESTION_TYPES } from '@/constants/constants.js'

import BaseMultiselect from '@/components/BaseMultiselect'
import BaseQuestionInput from '@/components/BaseQuestionInput'

export default {
  components: {
    BaseQuestionInput,
    BaseMultiselect
  },
  props: {
    questions: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      v$: useVuelidate(),
      QUESTION_TYPES: QUESTION_TYPES,
      isAnswerSaved: false,
      answers: [],
      firstLoad: true
    }
  },
  mixins: [validationMixin],
  validations() {
    return {
      answers: [
        ...(() => {
          return new Array(this.answers.length).fill({
            choices: {
              required
            },
            body: {
              required: requiredIf((_, answer) => {
                const questionType = this.findQuestion(answer.questionId).type
                if (questionType === QUESTION_TYPES.MULTIPLE_SELECT || questionType === QUESTION_TYPES.SINGLE_SELECT) {
                  return false
                }
                return true
              })
            },
            $trackBy: 'questionId'
          })
        })()
      ]
    }
  },
  watch: {
    questions: {
      // eslint-disable-next-line no-unused-vars
      handler(newQuestions, oldQuestions) {
        if (this.firstLoad) {
          newQuestions.forEach(question => {
            if (question.type === QUESTION_TYPES.MULTIPLE_SELECT) {
              delete question.selected
            }
            if (question.requirements.length < 1) {
              const choices = question.type === QUESTION_TYPES.INPUT ? [] : null
              this.answers.push({
                choices: choices,
                questionId: question.id
              })
            }
          })
          this.firstLoad = false
        }
      },
      deep: true
    }
  },
  methods: {
    formClickSendEvent() {
      event('form_actions', {
        event_action: 'form_clicked',
        form_name: 'Tarfin Yetkili Satış Noktası Kayıt'
      })
    },
    showElement(questionId) {
      document.getElementById('q_' + questionId).style.display = 'block'
    },
    hideElement(questionId) {
      document.getElementById('q_' + questionId).style.display = 'none'
    },
    isEqual(id, type, req) {
      if (type === 'choice') {
        if (req.subject_type === 'App\\Models\\Choice' && req.subject_id === id) {
          return true
        }
        return false
      } else if (type === 'subCategory') {
        if (req.subject_type === 'App\\Models\\SubCategory' && req.subject_id === id) {
          return true
        }
        return false
      }
      return false
    },
    checkRequirements(choiceId, checked) {
      this.questions.forEach(question => {
        question.requirements.forEach(requirement => {
          if (this.isEqual(choiceId, 'choice', requirement)) {
            if (checked) {
              this.addAnswer(question.id)
              this.showElement(question.id)
            } else {
              this.removeAnswer(question)
              this.hideElement(question.id)
            }
          }
        })
      })
    },
    checkRequirementsForRadioButton(choice) {
      this.questions.forEach(question => {
        if (question.id !== choice.question_id) {
          return
        }

        question.choices.forEach(ch => {
          this.questions.forEach(qs => {
            qs.requirements.forEach(req => {
              if (this.isEqual(ch.id, 'choice', req)) {
                this.removeAnswer(qs)
                this.hideElement(qs.id)
              }
            })
          })
        })
      })

      this.questions.forEach(question => {
        question.requirements.forEach(requirement => {
          if (this.isEqual(choice.id, 'choice', requirement)) {
            this.addAnswer(question.id)
            this.showElement(question.id)
          }
        })
      })
    },
    check: function (choice, e) {
      const answer = this.findAnswer(choice.question_id)

      answer.questionId = choice.question_id
      answer.choices = _.isArray(answer.choices) ? answer.choices : []

      if (e.target.checked) {
        answer.choices.push(choice.id)
      } else {
        answer.choices = answer.choices.filter(c => c !== choice.id)
      }

      this.checkRequirements(choice.id, e.target.checked)
    },
    updateInput(choice, event) {
      const foundIndex = this.answers.findIndex(x => x.questionId === choice.question_id)

      this.addAnswer(choice.question_id, choice.id, event.target.value)

      if (this.v$.answers[foundIndex]) {
        this.v$.answers[foundIndex].choices.$touch()
      }
    },
    updateRadio(choice) {
      const foundIndex = this.answers.findIndex(x => x.questionId === choice.question_id)
      this.addAnswer(choice.question_id, choice.id)

      this.checkRequirementsForRadioButton(choice)

      if (this.v$.answers[foundIndex]) {
        this.v$.answers[foundIndex].choices.$touch()
      }
    },
    status(question) {
      const foundIndex = this.answers.findIndex(x => x.questionId === question.id)
      if (foundIndex !== -1) {
        return this.validationStatuses(this.v$.answers[foundIndex].choices)
      }

      return
    },
    saveAnswer() {
      this.v$.$validate()
      if (!this.v$.$invalid) {
        this.$store
          .dispatch('retailerSurvey/saveRetailersAnswers', {
            answers: this.answers
          })
          .then(() => {
            this.isAnswerSaved = true
            this.eventEmitter.emit('retailerAnswerSaved')
          })
          .catch(() => {
            Nprogress.done()
          })
      }
    },
    singleSelect(selectedOption) {
      const answer = this.findAnswer(selectedOption.question_id)

      answer.choices = selectedOption.id
    },
    multipleSelect(selectedOption) {
      const answer = this.findAnswer(selectedOption.question_id)

      answer.questionId = selectedOption.question_id
      answer.choices = _.isArray(answer.choices) ? answer.choices : []
      answer.choices.push(selectedOption.id)
    },
    removeSelect(removedOption) {
      const answer = this.findAnswer(removedOption.question_id)

      if (answer.choices.length === 0) return
      answer.choices = answer.choices.filter(choice => choice !== removedOption.id)
    },
    findAnswer(questionId) {
      const index = this.answers.findIndex(answer => answer.questionId === questionId)

      return this.answers[index]
    },
    findQuestion(questionId) {
      const index = this.questions.findIndex(question => question.id === questionId)

      return this.questions[index]
    },
    addAnswer(questionId, choices, value) {
      const foundIndex = this.answers.findIndex(x => x.questionId === questionId)
      choices = choices || ''

      const question = _.findLast(this.questions, function (q) {
        return q.id === questionId
      })

      if (foundIndex === -1) {
        if (question.type === 1) {
          choices = choices ? [choices] : []
        }

        this.answers.push({
          choices: choices,
          questionId: questionId,
          body: value
        })
      } else {
        if (question.type === 1) {
          this.answers[foundIndex].choices.push(choices)
        } else {
          this.answers[foundIndex].choices = choices
        }

        this.answers[foundIndex].body = value
      }
    },
    removeAnswer(question) {
      const foundIndex = this.answers.findIndex(x => x.questionId === question.id)
      if (foundIndex !== -1) {
        this.answers.splice(foundIndex, 1)
      }
    }
  },
  mounted() {
    if (this.firstLoad) {
      this.questions.forEach(question => {
        if (question.type === QUESTION_TYPES.MULTIPLE_SELECT) {
          delete question.selected
        }
        if (question.requirements.length < 1) {
          const choices = question.type === QUESTION_TYPES.INPUT ? [] : null
          this.answers.push({
            choices: choices,
            questionId: question.id
          })
        }
      })
      this.firstLoad = false
    }
  }
}
</script>
<style lang="scss"></style>
